import { useState, useEffect, useContext, useRef } from "react";
import { Configuration_func } from "../../../api/automation/configuration_func_comp";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
//import { DataTable } from "../../../components/data_table/dataTable.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import handleNextBtnClick from "../../../components/side_menu/overlay_side_menu.component";
import DialogBox from "../../../components/dialog/dialog.component";
import { ToastComponent } from "../../../components/toast/toast.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Stack, StackItem } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Badge, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Theme, createLightTheme, createDarkTheme, BrandVariants, createTableColumn, TableCellLayout, Card, Image, Input, CardHeader, Tooltip, Spinner } from "@fluentui/react-components";
import { AddSquare20Regular, SaveCopy20Regular, Delete20Regular, BookTemplate20Regular, ChatMultipleHeart20Regular, CalendarClock20Regular, Wand20Regular, SettingsCogMultiple20Regular, Filter20Filled, FilterDismiss20Filled, Desktop20Filled, ArrowMaximize20Regular, DismissSquare24Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, ArrowMaximize16Regular, Save20Regular, Info20Filled, Dismiss16Regular, CheckmarkLock20Regular, MoreHorizontal20Regular, DismissSquareRegular, AlertBadge20Regular, AppsAddIn20Regular, ShieldLock20Regular, SquareHintApps20Regular, CheckboxCheckedSync20Regular, UninstallApp20Regular, PulseSquare20Regular, BoxCheckmark20Regular, AppsList20Regular, AppsListDetail20Filled, Info16Filled } from "@fluentui/react-icons";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { Resize } from "../../../components/textarea/textarea.component";
import { Checked } from "../../../components/switch/switch.component";
import { Inputs } from "../../../components/textarea/input.component";
import { Intent } from "../../../components/messagebar/messagebar.component";
import { Form } from '@rjsf/fluent-ui';
import validator from '@rjsf/validator-ajv8';
import { CustomWidgets } from '../../../components/form-components';
import { GlobalContext } from "../../../hooks/globalContext";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { fullscreenIcon, primaryIcon, secondaryIcon, exitIcon, messageTheme, lightTheme, oveyAlignment, heightResponsive, parentHome, DynamicBoxingCSS, wraperStyle, SubSectionResponsive, buttonContent, timezoneInfo, dashboardTheme, BreadcrumbsBorder } from "../../../styles/customStyles";
import { shouldLoadRoute } from "../../../Authentication/RouteProtection";
import { usePermissionStore } from "../../../Store/permissionStore";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import { convertToExcelFormat, convertToLocalTimezone, convertToUTCMoment, convertUTCToReadableFormat } from "../../../utility/utils";
import { useLocation } from "react-router-dom";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { DatepickerComponent } from "../../../components/picker/datepicker.component";
import { automationConfiguration } from "../../../api/automation/configuration_func";
import { InfoBar } from "../../../components/infoBar/infoBar.component";
import { AutomateAppPages } from "../../../components/side_menu/InlineSidenav";


const handleExportCSV = () => {
  // Programmatically trigger the CSV export link
  const csvExportLink = document.getElementById('csv-export-link');
  if (csvExportLink) {
    csvExportLink.click();
  }
};

export const Appprotectionpolicies = () => {
  const navigate = useNavigate();
  const contextValue: any = useContext(GlobalContext);
  var tenantName = contextValue.tenantName;
  const dartNo: number = parseInt(contextValue.dartNo);
  var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / ');
  const [final_data, set_final_data]: any = useState(null);
  const [tableData, setTableData] = useState([]);
  const formRef = useRef(null);
  const [leftOpen, setLeftOpen] = useState(false);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [overlayName, setOverlayName] = useState('');
  const [searchVal, setSearchVal] = useState("");
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [isFilter, setIsFilter] = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isdeletedisabled, setDeleteDisabled] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const [activeTab, setActiveTab] = useState('Introduction');
  const [dartSpecs, setDartSpecs]: any = useState([]);
  const [automationOverLayData, setAutomationOverLayData]: any = useState([]);
  const [jsonSchema, setJsonData]: any = useState({});
  const [uiSchema, setUiData]: any = useState({});
  const [spinnerLoad, setSpinnerLoad] = useState(true);
  const [formData, setFormData]: any = useState({
    name: '',
    description: '',
    jsonData: ''
  });
  const [formEditedData, setFormEditedData]: any = useState({
    name: '',
    description: '',
    jsonData: ''
  });
  const [deleteAutomation, setDeleteAutomation]: any = useState(false);
  const [isRefresh, setRefresh]: any = useState(false);
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [saveBtnClicked, setSaveBtnClicked]: any = useState(false);
  const [rowID, setRowID]: any = useState(null);
  const [isToast, setIsToast] = useState(false);
  const [automationStatus, setAutomationStatus] = useState('not attached');
  const [errorToast, setErrorToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  console.log("jsonschemas", jsonSchema)
  const [exportData, setExportData] = useState([]);
  const [exportDetails, setExportDetails]: any = useState([]);
  const [classificationNameValidation, setClassificationNameValidation]: any = useState(true);
  const [selectedAutomation, setSelectedAutomation] = useState('');
  const [selectedValue, setSelectedValue] = useState(0);
  const [dropdownData, setDropdownData] = useState<any | null>(null);
  const [dropDownValue, setDropDownValue] = useState<any>('');
  const [dartTemplatesList, setDartTemplatesList] = useState<any>([]);
  const { permissions } = usePermissionStore();
  const [loading, setLoading] = useState(true);
  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  const [uniqueCreatedBy, setUniqueCreatedBy] = useState<string[]>([]);
  const [isCreatedBy, setCreatedBy] = useState<any[]>([]);
  const [tableColumnsData, setTableColumnsData] = useState([]);
  const [filterColumnsData, setFilterColumnsData] = useState([]);
  const [disableConfirmBtn, setDisableConfirmBtn] = useState(false);
  useEffect(() => {
    // Direct, simple filtering
    const matchingData = final_data?.filter(
      item => 
        contextValue?.selectedRowIdInTable.includes(item.id) && 
        item.status !== "not attached"
    ) || [];
  
    // Set disable state based on matching data
    setDisableConfirmBtn(matchingData.length > 0);
  }, [contextValue?.selectedRowIdInTable]);

  useEffect(() => {
    const createdByOptions = uniqueCreatedBy.map((item) => {
      return { key: item, label: <Caption1>{item}</Caption1>, };
    });
    setCreatedBy(createdByOptions);
    console.log("Created By Options:", createdByOptions);
  }, [uniqueCreatedBy]);

  console.log("selected valueee", selectedValue)
  // console.log("CHECKING THE ERROR HOOK",error)
  const handlenextbutton = () => {
    setActiveTab('Configure');
  }

  const handleFilterArray = (): any => {
    const value1 = dropDownValue1;
    // const value2 = convertToUTCMoment(dropDownValue2);
    const value2 = dropDownValue2;
    console.log('handleFilterArray dropDownValue2 : ' + dropDownValue2);
    // if(value1 !== undefined && value1 !== '' && value2 !== undefined && value2 !== '') {
    const result = value1 + " : " + value2;
    setFilterArray([...filterArray, result])
    setIsFilter(true);
    setDropDownValue1('');
    setDropDownValue2('');
    // }
  }

  const handleCloseFilter = (index: any): any => {
    console.log("clicked");
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
    setLoading(true);
  }

  console.log("dartSpecs",dartSpecs)

  useEffect(() => {
    if (dartSpecs?.length > 0) {
      setIsDisabled(false);
      setSpinnerLoad(false);
    } else {
      setIsDisabled(true);
      setSpinnerLoad(true);
    }
  }, [dartSpecs])

  useEffect(() => {
    if (filterArray.length > 0) {
      setResetDisabled(false)
    } else {
      setResetDisabled(true)
    }
  }, [filterArray])

  const handle = useFullScreenHandle();

  const buttonref: any = useRef(null);
  const handleOutsideButton = () => {
    buttonref?.current?.click();
  };
  const inputChange = (e: any) => {
    const enteredValue = e.target.value;
    console.log("entered value", enteredValue)
    let name = e.target.name;
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9_-]*$/;
    const regexN = /^[A-Za-z0-9 ]*$/;

    if (name === 'filter' && dropDownValue1 === ("Name")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
    if (name === 'filter' && dropDownValue1 === ("Status")) {
      if (regexS.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
    if (name === 'filter' && dropDownValue1 === ("Description")) {
      if (regexN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
  }

  const handleAddBtnClick = () => {
    setFormData({ name: '', description: '', jsonData: '' });
    setOverlayName('addAutomation');
    setSpinnerLoad(false);
    contextValue.setDartNo(0);
    setSelectedValue(0);
    setAutomationStatus('not attached');
    setTimeout(() => {
      setOverlayOpen(true);
    }, 100);
  }

  const location = useLocation();
  useEffect(() => {
    if (overlayOpen) {
      const element = document.getElementById("fluent-default-layer-host");
      if (element) {
        element.style.zIndex = '9999999';
      }
    }
  }, [overlayOpen]);

  const iconStyleProps: any = {
    primaryFill: "#008099",
    className: "iconClass",
  };

  // const somefunction =()=>{
  //   const form = document.getElementById("myForm");
  //   form?.addEventListener("submit", function(event) {
  //   const requiredFields = form?.querySelectorAll("[required]");
  //   let isEmpty = false;
  //   for (let i = 0; i < requiredFields.length; i++) {
  //     const field = requiredFields[i];
  //     alert("here")
  //     if ((field as HTMLInputElement)?.value?.trim() === "") {
  //       isEmpty = true;
  //       alert("fill the form")
  //       event.preventDefault(); 
  //       // break;
  //     }
  //     return true;
  //   }
  //   if (!isEmpty) {
  //    alert("form filled");
  //   }
  //   return false;
  // });
  // }

  const handleSubmit = (e: any) => {
    e.preventDefault();
    // handleNextBtnClick(e);
  }

  // const validate=()=>{
  //   console.log(formData.name);
  //   setError(false);
  //   if(formData.name === '')
  //   { console.log("CODE CHECK WHEN DATA EMPTY")
  //     setError(true);
  //   }
  //   if(formData?.name)
  //   { console.log("CODE CHECK WHEN DATA NOT EMPTY")
  //     setError(false)
  //   }
  // }

  useEffect(() => {
    // const filtereddropdata=dartTemplatesList?.filter((val:any,i:any)=>{ val.templateName ==""  && return { key: `op_${i+1}`, label: <Body1> {val.templateName} </Body1>}}); 
    // console.log("darttemplate",dartTemplatesList);
    // console.log("filtered option data",filtereddropdata)
    var dropDownDataObj = dartTemplatesList?.map((val: any, i: any) => { return { key: `op_${i + 1}`, label: <Body1 onClick={() => { setSelectedValue(parseInt(val.dartNo)); contextValue.setDartNo(val.dartNo) }}> {val.templateName} </Body1> } });

    setDropdownData(dropDownDataObj);

  }, [dartTemplatesList]);

  // const filteroptiondata= dropdownData != null ? dropdownData.filter((val:any)=>(val == "161" || val =="296" || val == "225")) : ""

  console.log("isDisabled", isDisabled)
  useEffect(() => {
    var flag = true;
    exportDetails.map((val: any) => {
      if (val.automationName === formData.name || (overlayName == 'editAutomation' && val.automationName === formEditedData.name)) {
        flag = false;
      }
    });

    if (overlayName == 'editAutomation' && formEditedData.name === selectedAutomation) {
      flag = true;
    }

    setClassificationNameValidation(flag);
  }, [formData, formEditedData, selectedAutomation]);

  var tableColumns: any[] = [];
  var filterColumns: any[] = [];
  useEffect(() => {
    contextValue?.tableColumnsData?.appsAutomate?.Protection_Policy.forEach((val) => {
      if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
        if (val.key === "created_on_timezoned" || val.key === "last_modified_timezoned") {
          tableColumns[val.priority] = ({
            key: val.key,
            label:
              <>
                <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                  <StackItem>
                    <Body1Strong>{`${val.name}`}</Body1Strong>
                  </StackItem>
                  <StackItem align="center">
                    <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                      <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
                    </Tooltip>
                  </StackItem>
                </Stack>
              </>
          });
        } else {
          tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
        }
      }

      if (val.display.filter.toLocaleLowerCase() === "yes") {
        filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
      }
    });

    setTableColumnsData(tableColumns);
    setFilterColumnsData(filterColumns);
    contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.appsAutomate?.Protection_Policy.filter((val) => val.priority >= 0));
    contextValue.setManageViewPageDetails({ module: "appsAutomate", page: "Protection_Policy" });
  }, [contextValue.tableColumnsData]);
  //data table column name code starts here
  // var columns = [
  //   { key: "name", label: <Body1Strong> Name </Body1Strong> },
  //   { key: "description", label: <Body1Strong> Description </Body1Strong> },
  //   { key: "created_by", label: <Body1Strong> Created by </Body1Strong> },
  //   { key: "created_on", label: <Body1Strong> Created On (UTC) </Body1Strong> },
  //   { key: "created_on_timezoned", label: <Body1Strong> Created On ({formattedTimeZone}) </Body1Strong> },
  //   { key: "last_modified", label: <Body1Strong> Last Modified (UTC) </Body1Strong> },
  //   { key: "last_modified_timezoned", label: <Body1Strong> Last Modified ({formattedTimeZone}) </Body1Strong> },
  //   { key: "status", label: <Body1Strong> Status </Body1Strong> },
  // ];
  // //data table column name code ends here

  // var columns1 = [
  //   { key: "name", label: <Caption1> Name </Caption1> },
  //   { key: "description", label: <Caption1> Description </Caption1> },
  //   { key: "created_by", label: <Caption1> Created by </Caption1> },
  //   { key: "created_on", label: <Caption1> Created On </Caption1> },
  //   { key: "last_modified", label: <Caption1> Last Modified </Caption1> },
  //   { key: "status", label: <Caption1> Status </Caption1> },
  // ];

  // overflow set contents code starts here
  var overFlowComponent = {
    data:
      <>
        {permissions.includes("all") || permissions.includes("configuration_Fullaccess") ?
          <StackItem onClick={handleAddBtnClick}>
            <Button shape="circular" disabled={loading} appearance="subtle" size="small">
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem>{loading ?
                  <AddSquare20Regular {...secondaryIcon} />
                  : <AddSquare20Regular {...primaryIcon} />}</StackItem>
                <StackItem> <Caption1> Create Device Protection Policy </Caption1> </StackItem>
              </Stack>
            </Button>
          </StackItem>
          :
          <StackItem>
            <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
              <Button shape="circular" appearance="subtle" size="small" disabled>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem><Text></Text></StackItem>
                  <StackItem>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem> <AddSquare20Regular {...secondaryIcon} /> </StackItem>
                      <StackItem><Caption1> Create Device Protection Policy </Caption1></StackItem>
                    </Stack>
                  </StackItem>
                </Stack>
              </Button>
            </Tooltip>
          </StackItem>
        }

        <StackItem>
          <Divider vertical />
        </StackItem>

        {/* <StackItem>
          <Button shape="circular" appearance="subtle" size="small">
            <Stack tokens={{childrenGap:5}} horizontal>
              <StackItem> <SaveCopy20Regular {...primaryIcon}/> </StackItem>
              <StackItem> <Caption1> Duplicate </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>
        <StackItem>
        <Divider vertical/>
        </StackItem> */}
        <StackItem>
          <DialogBox
            headerButton={
              <>
                <Button shape="circular" appearance="transparent" size="small"
                  disabled={isdeletedisabled ? true : false} >
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem>
                      {/* <Delete20Regular {...primaryIcon} />  */}
                      {isdeletedisabled
                        ? (<Delete20Regular {...secondaryIcon} />)
                        : (<Delete20Regular {...primaryIcon} />)
                      }
                    </StackItem>
                    <StackItem> <Caption1> Delete </Caption1> </StackItem>
                  </Stack>
                </Button>
              </>
            }

            content={disableConfirmBtn ? "Enabled automation cannot be deleted. Please disable or unselect the enabled automation and try again." : "Please confirm if you want to proceed with deleting the automation."}

            footer=
            {
              <>
                <Stack horizontal tokens={{ childrenGap: 10 }}>
                  <StackItem>
                    <Button shape="circular" disabled={disableConfirmBtn} appearance="primary" onClick={() => { setDeleteAutomation(true); }} size="small">Confirm</Button>
                  </StackItem>
                  <StackItem>
                    <Button shape="circular" size="small">Cancel</Button>
                  </StackItem>
                </Stack>
              </>
            }
          />
        </StackItem>
        <StackItem>
          <Divider vertical />
        </StackItem>
        <StackItem>
          <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setRefresh(true); setLoading(true); setCurrentPageNo(1) }}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem>{loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />}</StackItem>
              <StackItem> <Caption1> Refresh </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>

        {permissions.includes("all") || permissions.includes("configuration_Fullaccess") || permissions.includes("configuration_ReadandExport") ?
          <StackItem>
            <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_configurationlist.csv`}>
            </CSVLink>
            <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => { setExportBtnClicked(true); /*userActivity('Export', `{"summary":"Automation list exported"}`);*/ }}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                <StackItem> <Caption1> Export </Caption1> </StackItem>
              </Stack>
            </Button>
          </StackItem>
          :
          <StackItem>
            <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
              <Button shape="circular" appearance="subtle" size="small" disabled>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem><Text></Text></StackItem>
                  <StackItem>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                      <StackItem><Caption1> Export </Caption1></StackItem>
                    </Stack>
                  </StackItem>
                </Stack>
              </Button>
            </Tooltip>
          </StackItem>
        }

        <StackItem>
          <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => document.getElementById("manageView").click()}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> {loading || tableData.length === 0 ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />}  </StackItem>
              <StackItem> <Caption1> Manage View </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>
      </>
    ,
  };
  // overflow set contents code ends here

  const handleNewFormChange = (e: any) => {
    setFormData({
      ...formData,
      jsonData: e.formData
    });
  }

  const handleEditFormChange = (e: any) => {
    setFormEditedData({
      ...formEditedData,
      jsonData: e.formData
    });
  }

  let dartToShow: string = "registry";
  var tempTableData: any = [];
  var tempExportData: any = [];

  useEffect(() => {
    var tempExportData: any = [];
    var status = '';

    exportDetails?.length > 0 && exportDetails.map((val: any) => {
      if (val.status == 'not attached') {
        status = 'Not attached';
      } else {
        var curStatus = val.status?.split("|").filter((val: any) => val.includes(`${contextValue.tenantName}:`));

        if (curStatus.length == 0) {
          status = 'Not attached';
        } else {
          curStatus = curStatus[0]?.split(":")[1];

          if (curStatus == 'all') {
            status = 'Enabled for All Devices';
          } else {
            status = curStatus?.split(",").length == 1 ? `Enable for ${curStatus?.split(",").length} Device Classification` : `Enable for ${curStatus?.split(",").length} Device Classifications`;
          }
        }
      }

      tempExportData.push({
        'Name': val.automationName,
        'Description': val.description,
        'Created By': (val.createdBy != undefined && val.createdBy?.length > 0) ? val.createdBy : "-",
        'Created On': convertToExcelFormat(val.createdOn),
        'Last Modified': val.lastModified ? convertToExcelFormat(val.lastModified) : "-",
        'Status': status
      });
    });

    setExportData(tempExportData);
  }, [exportDetails]);

  useEffect(() => {
    exportData.length > 0 && document.getElementById('csv-export-link')?.click();
  }, [exportData]);

  // useEffect(() => {
  //   //roles and permissions
  //   async function loadRoute() {
  //     console.log("role:-",sessionStorage.getItem('role'))
  //     const role = sessionStorage.getItem('role');

  //     try {
  //       const [routeAllowed, permissions] = await shouldLoadRoute(role);

  //       if (routeAllowed) {
  //         console.log("permission===",permissions);

  //         setPermissions(permissions)
  //       } else {
  //         console.log('Route is not allowed.');
  //       }
  //     } catch (error) {
  //       console.error('Error loading route:', error);
  //     }
  //   }

  //   loadRoute();
  // }, []);
  useEffect(() => {
    if (final_data !== undefined && final_data !== null) {
      const newUniqueCreatedBy: string[] = [];

      final_data?.forEach((val: any) => {
        if (val.createdBy && val.createdBy.trim() !== "-" && !newUniqueCreatedBy.includes(val.createdBy)) {
          newUniqueCreatedBy.push(val.createdBy);
        }
      });

      setUniqueCreatedBy(newUniqueCreatedBy);
      console.log("Unique Created By:", newUniqueCreatedBy);
    } else {
      setUniqueCreatedBy([]);
    }
  }, [final_data]);

  useEffect(() => {
    // data table values append code starts here
    var status = '';
    final_data !== undefined && final_data !== null
      ? final_data.map((val: any, i: any) => {
        if (val.status == 'not attached') {
          status = 'Not attached';
        } else {
          var curStatus = val.status?.split("|").filter((val: any) => val.includes(`${contextValue.tenantName}:`));

          if (curStatus.length == 0) {
            status = 'Not attached';
          } else {
            curStatus = curStatus[0]?.split(":")[1];

            if (curStatus == 'all') {
              status = 'Enabled for All Devices';
            } else {
              status = curStatus?.split(",").length == 1 ? `Enable for ${curStatus?.split(",").length} Device Classification` : `Enable for ${curStatus?.split(",").length} Device Classifications`;
            }
          }
        }
        {
          permissions.includes("appProtectProfile_Fullaccess") || permissions.includes("all") ?

            tempTableData.push({
              id: val.id,
              checkbox: "show",
              name: { label: <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small" onClick={() => { setRowID(val.id); contextValue.setDartNo(val.dartid); setOverlayOpen(true); setOverlayName('editAutomation'); val.status.includes(`${contextValue.tenantName}:`) ? setAutomationStatus('attached') : setAutomationStatus('not attached'); setSelectedAutomation(val.automationName); setSpinnerLoad(true)}}> {val.automationName} </Button> },
              description: { label: <Caption1> {val.description} </Caption1>, status: "" },
              created_by: { label: <Caption1> {val.createdBy} </Caption1> },
              created_on: { label: <Caption1> {convertUTCToReadableFormat(val.createdOn)} </Caption1> },
              created_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.createdOn, userTimeZone)} </Caption1> },
              last_modified: { label: <Caption1> {convertUTCToReadableFormat(val.lastModified)} </Caption1> },
              last_modified_timezoned: { label: <Caption1> {convertToLocalTimezone(val.lastModified, userTimeZone)} </Caption1> },
              status: { label: <Caption1> {status} </Caption1> },
            })
            :
            tempTableData.push({
              id: val.id,
              checkbox: "hide",
              name: {
                label: <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                  <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small"> {val.automationName} </Button></Tooltip>
              },
              description: { label: <Caption1> {val.description} </Caption1>, status: "" },
              created_by: { label: <Caption1> {val.createdBy} </Caption1> },
              created_on: { label: <Caption1> {convertUTCToReadableFormat(val.createdOn)} </Caption1> },
              created_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.createdOn, userTimeZone)} </Caption1> },
              last_modified: { label: <Caption1> {convertUTCToReadableFormat(val.lastModified)} </Caption1> },
              last_modified_timezoned: { label: <Caption1> {convertToLocalTimezone(val.lastModified, userTimeZone)} </Caption1> },
              status: { label: <Caption1> {status} </Caption1> },
            })
        }
      }) : (tempTableData = []);
    tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
    setTimeout(() => {
      final_data !== undefined && final_data !== null && setLoading(false);

      if (isRefresh) {
        setRefresh(false);
        setRefreshToast(true);
        setTimeout(() => {
          setRefreshToast(false);
        }, 3000);
      }
    }, 500);
  }, [final_data, permissions]);
  // data table values append code ends here


  useEffect(() => {
    if (Object.keys(jsonSchema).length > 0) {
      var varValues = Object.keys(jsonSchema?.properties);

      var tempObj: any = {};
      varValues.map((ele: any) => {
        if (jsonSchema.properties[`${ele}`].hasOwnProperty("properties")) {
          var subVarValues: any = Object.keys(jsonSchema.properties[`${ele}`].properties);

          subVarValues.map((val: any) => {
            if (tempObj.hasOwnProperty(ele)) {
              tempObj[`${ele}`] = { ...tempObj[`${ele}`], [`${val}`]: jsonSchema.properties[`${ele}`]?.properties[`${val}`]?.default };
            } else {
              tempObj[`${ele}`] = { [`${val}`]: jsonSchema.properties[`${ele}`]?.properties[`${val}`]?.default };
            }
          })
        } else {
          tempObj[`${ele}`] = jsonSchema.properties[`${ele}`]?.default;
        }
      });

      setFormData({
        ...formData,
        jsonData: tempObj
      });
    }
  }, [jsonSchema]);

  useEffect(() => {
    var templateName = '';
    var os: any = [];
    var details = "{}";
    if (dartSpecs?.length > 0 || selectedValue === 0) {
      details = dartSpecs?.length > 0 ? dartSpecs[0]?.details : "{}";
      details = JSON.parse(details);

      os = dartSpecs?.length > 0 ? dartSpecs[0]?.supportingOS : [];

      templateName = dartSpecs?.length > 0 ? dartSpecs[0]?.templateName : '';
    }
    overlayName == 'addAutomation' && setAutomationOverLayData({
      headerTitle: "Create Device Protection Policy",
      size: "large",
      isTabs: true,
      tabItems: {
        Introduction: selectedValue === 0 ? <form style={oveyAlignment} autoComplete="off" id="myForm" onSubmit={(e) => handleSubmit(e)}> <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem> <Body1Strong>Choose the template <Image src="/Dashboard/image/required.svg" /></Body1Strong> </StackItem>
          <StackItem>
            <DropdownComponent optionData={dropdownData} setDropDownValue={setDropDownValue} dropDownvalue={dropDownValue} required={true} />
          </StackItem>
        </Stack>
        </form>
          : <form style={oveyAlignment} autoComplete="off" id="myForm" onSubmit={(e) => handleSubmit(e)}>
            <Stack style={oveyAlignment} tokens={{ childrenGap: 15, padding: "10px 0px" }}>
              <StackItem>
                <Body1Strong>Choose the template <Image src="/Dashboard/image/required.svg" /></Body1Strong>
              </StackItem>

              <StackItem>
                <DropdownComponent defaultSelected={dropDownValue} optionData={dropdownData} setDropDownValue={setDropDownValue} dropDownvalue={dropDownValue} required />
              </StackItem>
              {dartSpecs?.length > 0 ? <>
                {dropDownValue !== "" && <Stack tokens={{ childrenGap: 15 }}>
                  <StackItem>
                    <p> <b>Name <Image src="/Dashboard/image/required.svg" /></b></p>
                  </StackItem>
                  <StackItem>
                    <p> <Inputs inputChange={setFormData} inputVal={formData} required={true} /></p>
                    {!classificationNameValidation && <Body1>This automation name already exists</Body1>}
                  </StackItem>

                  <StackItem>
                    <p> <b>What does this Automation Do?</b></p>
                  </StackItem>
                  <StackItem>
                    <p> <Resize inputChange={setFormData} inputValue={formData} /></p>
                  </StackItem>
                </Stack>}

                <InfoBar title={"These are the basic details associated with this automation."} />

                <StackItem>
                  <Stack horizontal horizontalAlign="space-between">
                    <StackItem>
                      <Stack horizontal tokens={{ childrenGap: 5 }} >
                        <Body1Strong>Operating System - &nbsp;</Body1Strong>
                        {os.includes('windows') && <StackItem> <Image src="/Dashboard/image/cardWindows.svg" alt="Windows" /> </StackItem>}
                        {os.includes('android') && <StackItem> <Image src="/Dashboard/image/cardAndroid.svg" alt="Android" /> </StackItem>}
                        {os.includes('ios') && <StackItem> <Image src="/Dashboard/image/cardIos.svg" alt="Ios" /> </StackItem>}
                      </Stack>
                    </StackItem>
                  </Stack>
                </StackItem>

                {Object.keys(details).map(key => (
                  <>
                    <StackItem>
                      <p><b>{key}</b></p>
                    </StackItem>
                    <StackItem>
                      <p>{details[key]}</p>
                    </StackItem>
                  </>
                ))}</> :
                <Stack verticalAlign="center" style={oveyAlignment}>
                  <Spinner />
                </Stack>}
            </Stack>
            <Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}>Validate</Button>
          </form>,
        Configure: <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            <Form ref={formRef} formData={formData.jsonData} schema={jsonSchema} uiSchema={uiSchema} validator={validator} widgets={CustomWidgets} onChange={(e) => handleNewFormChange(e)} />
          </StackItem>
        </Stack>,
        'Review Data': <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            <p> <Body1Strong>Name</Body1Strong></p>
          </StackItem>
          <StackItem>
            <p> <Inputs inputChange={setFormData} inputVal={formData} disabled={true} /></p>
          </StackItem>

          <StackItem>
            <Body1Strong>What does this Automation Do?</Body1Strong>
          </StackItem>
          <StackItem>
            <p> <Resize inputChange={setFormData} inputValue={formData} disabled={true} /></p>
          </StackItem>

          <StackItem>
            <Form formData={formData.jsonData} schema={jsonSchema} uiSchema={uiSchema} validator={validator} widgets={CustomWidgets} disabled />
          </StackItem>
        </Stack>
      },
    });

    Object.keys(formData).length > 0 && overlayName === 'editAutomation' && automationStatus === 'not attached' && setAutomationOverLayData({
      headerTitle: `Edit ${selectedAutomation} automation`,
      size: "large",
      isTabs: true,
      tabItems: {
        Introduction: isDisabled?
        <Stack horizontal verticalAlign="center" horizontalAlign="center" style={DynamicBoxingCSS}>
        <Spinner/>
        </Stack>
        :<form autoComplete="off" id="myForm" onSubmit={(e) => handleSubmit(e)}>
          <Stack tokens={{ childrenGap: 2 }}>
            <Stack tokens={{ childrenGap: 5, padding: "10px 0px" }}>
              <StackItem><Text></Text></StackItem>
              <StackItem><Text></Text></StackItem>
              <StackItem><Text></Text></StackItem>
              <StackItem>
                <Body1Strong>Template name - </Body1Strong> <Body1Strong>{templateName}</Body1Strong>
              </StackItem>
            </Stack>
            <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
              <StackItem>
                <p> <b>Name <Image src="/Dashboard/image/required.svg" /></b></p>
              </StackItem>
              <StackItem>
                <p> <Inputs inputChange={setFormEditedData} inputVal={formEditedData} required={true} /></p>
                {!classificationNameValidation && <Body1>This automation name already exists</Body1>}
              </StackItem>

              <StackItem>
                <p> <b>What does this Automation Do?</b></p>
              </StackItem>
              <StackItem>
                <p> <Resize inputChange={setFormEditedData} inputValue={formEditedData} /> </p>
              </StackItem>
            </Stack>

            {/* <StackItem>
                <DropdownComponent defaultSelected={dropDownValue} optionData={dropdownData} setDropDownValue={setDropDownValue} dropDownvalue={dropDownValue} required />
              </StackItem> */}

            <InfoBar title={"These are the basic details associated with this automation. "} />
            <StackItem>
              <Stack horizontal horizontalAlign="space-between">
                <StackItem>
                  <Stack horizontal tokens={{ childrenGap: 5 }}>
                    <Body1Strong>Operating System - &nbsp;</Body1Strong>
                    {os.includes('windows') && <StackItem> <Image src="/Dashboard/image/cardWindows.svg" alt="Windows" /> </StackItem>}
                    {os.includes('android') && <StackItem> <Image src="/Dashboard/image/cardAndroid.svg" alt="Android" /> </StackItem>}
                    {os.includes('ios') && <StackItem> <Image src="/Dashboard/image/cardIos.svg" alt="Ios" /> </StackItem>}
                  </Stack>
                </StackItem>
              </Stack>
            </StackItem>

            {Object.keys(details).map(key => (
              <>
                <StackItem>
                  <p><b>{key}</b></p>
                </StackItem>
                <StackItem>
                  <p>{details[key]}</p>
                </StackItem>
              </>
            ))}
          </Stack>
          <Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}>Validate</Button>
        </form>,

        Configure: <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <Form ref={formRef} formData={formEditedData.jsonData} schema={jsonSchema} uiSchema={uiSchema} validator={validator} widgets={CustomWidgets} onChange={(e) => handleEditFormChange(e)} />
        </Stack>,

        'Review Data': <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            <p> <Body1Strong>Name</Body1Strong></p>
          </StackItem>
          <StackItem>
            <p> <Inputs inputChange={setFormEditedData} inputVal={formEditedData} disabled={true} /></p>
          </StackItem>

          <StackItem>
            <Body1Strong>What does this Automation Do?</Body1Strong>
          </StackItem>
          <StackItem>
            <p> <Resize inputChange={setFormEditedData} inputValue={formEditedData} disabled={true} /></p>
          </StackItem>

          <StackItem>
            <Form formData={formEditedData.jsonData} schema={jsonSchema} uiSchema={uiSchema} validator={validator} widgets={CustomWidgets} disabled />
          </StackItem>
        </Stack>
      },
    });

    Object.keys(formData).length > 0 && overlayName === 'editAutomation' && automationStatus !== 'not attached' && setAutomationOverLayData({
      headerTitle: `${selectedAutomation} automation`,
      size: "large",
      isTabs: true,
      tabItems: {
        'Configuration': <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            <p> <b>Name</b></p>
          </StackItem>
          <StackItem>
            <p> <Inputs inputChange={setFormEditedData} inputVal={formEditedData} disabled={true} /></p>
          </StackItem>

          <StackItem>
            <p> <b>What does this Automation Do?</b></p>
          </StackItem>
          <StackItem>
            <p> <Resize inputChange={setFormEditedData} inputValue={formEditedData} disabled={true} /></p>
          </StackItem>

          <StackItem>
            <Form formData={formEditedData.jsonData} schema={jsonSchema} uiSchema={uiSchema} validator={validator} widgets={CustomWidgets} disabled />
          </StackItem>
        </Stack>
      },
    });

  }, [overlayName, dartSpecs, formData, formEditedData, dropDownValue, classificationNameValidation]);

  useEffect(() => {
    !overlayOpen && setOverlayName('');
  }, [overlayOpen]);

  useEffect(() => {
    contextValue.setSelectedRowIdInTable([]);
  }, []);

  useEffect(() => {
    contextValue.selectedRowIdInTable.length > 0 ? setDeleteDisabled(false) : setDeleteDisabled(true);
  }, [contextValue.selectedRowIdInTable]);

  useEffect(() => {
    const pageNo = (currentPageNo - 1) * 50;

    const props: any = {
      rowID: rowID,
      selectedRowIdInTable: contextValue.selectedRowIdInTable,
      tenant: tenantName,
      dartNo: dartNo,
      data: final_data,
      func: set_final_data,
      setDartSpecs: setDartSpecs,
      searchVal: searchVal,
      pageNo: pageNo,
      setTotalPages: setTotalPages,
      setTotalRecords: setTotalRecords,
      isFilter: isFilter,
      setIsFilter: setIsFilter,
      dropDownValue1: dropDownValue1,
      dropDownValue2: dropDownValue2,
      setJsonData: setJsonData,
      setUiData: setUiData,
      deleteAutomation: deleteAutomation,
      setDeleteAutomation: setDeleteAutomation,
      setDeleteDisabled: setDeleteDisabled,
      isRefresh: isRefresh,
      setRefresh: setRefresh,
      overlayName: overlayName,
      setIsToast: setIsToast,
      setRefreshToast: setRefreshToast,
      dropdownData: dropdownData,
      setDartTemplatesList: setDartTemplatesList,
      selectedValue: selectedValue,
      saveBtnClicked: saveBtnClicked,
      filterArray: filterArray,
      setErrorToast: setErrorToast,
      setToastMessage: setToastMessage,
      setOverlayOpen: setOverlayOpen,
      setSaveBtnClicked: setSaveBtnClicked,
      exportBtnClicked: exportBtnClicked,
      setExportBtnClicked: setExportBtnClicked,
      setExportDetails: setExportDetails,
      dartToShow: dartToShow,
      setLoading: setLoading,
      setSelectedRowIdInTable: contextValue.setSelectedRowIdInTable,
      dropDownValue: dropDownValue,
      setIsDisabled: setIsDisabled,
      setSpinnerLoad: {setSpinnerLoad}
    };

    if (saveBtnClicked) {
      props.newData = overlayName === 'addAutomation' ? formData : formEditedData;
      props.setFormData = overlayName === 'addAutomation' ? setFormData : setFormEditedData;
    } else if (overlayName !== '') {
      props.setFormData = overlayName === 'addAutomation' ? setFormData : setFormEditedData;
      props.formData = overlayName === 'addAutomation' ? formData : formEditedData;
    }

    if ((!saveBtnClicked && overlayName === '') || saveBtnClicked || overlayName !== '') {
      automationConfiguration(props);
    }
  }, [deleteAutomation, isRefresh, searchVal, saveBtnClicked, overlayName, rowID, currentPageNo, isFilter, selectedValue, filterArray, exportBtnClicked]);

  return (
    <>
      <FullScreen handle={handle} className="fullScreenBackgroundColor">
        <StackItem grow shrink style={BreadcrumbsBorder}>
          <Stack tokens={{ childrenGap: 10 }} horizontal>
            <StackItem grow shrink>
              <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                <StackItem><Text></Text></StackItem>
                <StackItem grow shrink>
                  <Breadcrumbs
                    items={[
											{name: "Automate", link: "/home" },
                      {name:"Apps", link:"/automate/apps/appmonitored"},
                      {name:"Device Protection Policies", link:"#"}
                    ]}
                  />
                </StackItem>
              </Stack>
            </StackItem>
            <StackItem grow shrink>
              <Stack horizontalAlign="end">
                <StackItem grow shrink>
                  <FullScreenButton handle={handle} />
                </StackItem>
              </Stack>
            </StackItem>
          </Stack>
        </StackItem>
        <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
          <StackItem style={DynamicBoxingCSS}>
            {/* pages code starts here */}
            <Stack style={DynamicBoxingCSS}>
              <FluentProvider style={parentHome} theme={dashboardTheme}>
                <Stack style={parentHome} horizontal >
                  {/* SPACING BETWEEN INLINE AND PAGE */}
                  <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={AutomateAppPages(`Device${" "}Protection${" "}Policies`)} />
                  <StackItem style={DynamicBoxingCSS}>
                    <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                      <StackItem>
                        <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                        <Divider />
                      </StackItem>
                      <StackItem style={wraperStyle}>
                        <StackItem>
                          <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                            <Stack horizontal tokens={{ childrenGap: 10 }}>
                              <StackItem>
                                <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                              </StackItem>
                              <StackItem>
                                <MenuDropdown open={filterMenuOpen} btn={
                                  <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                      <Body1> Filter </Body1>
                                    </Stack>
                                  </MenuButton>
                                } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                  <Divider />
                                  <MenuList>
                                    <Stack tokens={{ childrenGap: 5 }}>
                                      <StackItem> <Text></Text> </StackItem>
                                      <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                      {/* <DropdownComponent optionData={columns1} setDropDownValue = {setDropDownValue1} dropDownvalue = {dropDownValue1} /> */}
                                      <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                      <StackItem> <Divider /> </StackItem>
                                      <StackItem> <Caption1> Value </Caption1> </StackItem>
                                      {(dropDownValue1 === 'Created On' || dropDownValue1 === 'Last Modified') && <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />}
                                      {(dropDownValue1 === "Name") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                      {(dropDownValue1 === "Description") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                      {(dropDownValue1 === "Status") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                      {dropDownValue1 === "Created by" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={isCreatedBy} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                      <StackItem> <Divider /> </StackItem>
                                      <Stack tokens={{ childrenGap: 10 }} horizontal>
                                        <StackItem>
                                          <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                            disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                            <Caption1> Apply </Caption1>
                                          </Button>
                                        </StackItem>

                                        <StackItem>
                                          <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                            <Caption1> Cancel </Caption1>
                                          </Button>
                                        </StackItem>
                                      </Stack>
                                    </Stack>
                                  </MenuList>
                                </>} />
                              </StackItem>
                              <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); setLoading(true); }}>
                                <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem> <FilterDismiss20Filled /> </StackItem>
                                    <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                  </Stack>
                                </Button>
                              </StackItem>
                            </Stack>
                            {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                          </Stack>
                          <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
                            <StackItem>
                              {filterArray.length > 0 &&
                                // <Stack tokens={{ padding: '10px 0px 0px 0px' }}>
                                <Stack wrap horizontal >
                                  {filterArray.length > 0 && filterArray.map((item, index) => (
                                    <Button shape="circular" size="small">
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                        <StackItem>
                                          <Stack tokens={{ childrenGap: 1 }}>
                                            <StackItem><Text></Text></StackItem>
                                            <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                          </Stack>
                                        </StackItem>
                                      </Stack>
                                    </Button>
                                  ))}
                                  {/* </Stack> */}
                                </Stack>}
                            </StackItem>

                            <StackItem disableShrink>
                              {(tableData.length > 0 && !loading) && (
                                totalRecords > 0 &&
                                <Caption1>
                                  Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                                </Caption1>
                              )}
                            </StackItem>
                          </Stack>
                        </StackItem>
                        <InfoBar showSpaces={true} title={"Device Protection Policies allows you to report or restart stopped services in services.msc, apply Registry Protection, apply Directory and File Protection, and restrict USB access."} />
                      </StackItem>

                      {/* { !saveBtnClicked && overlayName == '' && <Configuration_func data={final_data} func={set_final_data} setDartSpecs={setDartSpecs} searchVal={searchVal} pageNo={(currentPageNo - 1) * 50} setTotalPages={setTotalPages} setTotalRecords={setTotalRecords} isFilter={isFilter} dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2} setJsonData={setJsonData} setUiData={setUiData} deleteAutomation={deleteAutomation} setDeleteAutomation={setDeleteAutomation} setDeleteDisabled={setDeleteDisabled} isRefresh={isRefresh} setRefresh={setRefresh} overlayName={overlayName} setIsToast={setIsToast} setRefreshToast={setRefreshToast} dropdownData={dropdownData} setDartTemplatesList={setDartTemplatesList} selectedValue={selectedValue} saveBtnClicked={saveBtnClicked} setExportDetails={setExportDetails} dartToShow={dartToShow} />}

                  {saveBtnClicked && <Configuration_func newData={overlayName === 'addAutomation' ? formData : formEditedData} saveBtnClicked={saveBtnClicked} isFilter={isFilter} dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2} setSaveBtnClicked={setSaveBtnClicked} overlayName={overlayName} rowID={rowID} setFormData={overlayName == 'addAutomation' ? setFormData : setFormEditedData} func={set_final_data} setIsToast={setIsToast} setOverlayOpen={setOverlayOpen} setErrorToast={setErrorToast} setToastMessage={setToastMessage} dropdownData={dropdownData} selectedValue={selectedValue} dartToShow={dartToShow} />}

                  {overlayName != '' && <Configuration_func rowID={rowID} overlayName={overlayName} setFormData={overlayName == 'addAutomation' ? setFormData : setFormEditedData} formData={overlayName == 'addAutomation' ? formData : formEditedData} isFilter={isFilter} dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2} setJsonData={setJsonData} setUiData={setUiData} setDartSpecs={setDartSpecs} setErrorToast={setErrorToast} setToastMessage={setToastMessage} dropdownData={dropdownData} selectedValue={selectedValue} saveBtnClicked={saveBtnClicked} isRefresh={isRefresh} deleteAutomation={deleteAutomation} dartToShow={dartToShow}/>} */}

                      {/* {tableData.length > 0 && (<DataTable tableData={tableData} columns={columns} setOverlayOpen={setOverlayOpen}></DataTable>)} */}

                      {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={tableColumnsData} setOverlayOpen={setOverlayOpen}></DataTable>) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                    </Stack>
                  </StackItem>
                </Stack>
              </FluentProvider>
            </Stack>
            <OverLay
              isDisabled={isDisabled}
              overlayopen={overlayOpen}
              setOverlayOpen={setOverlayOpen}
              overlayData={automationOverLayData}
              saveBtnFunc={setSaveBtnClicked}
              isNavBtn={automationStatus !== 'not attached' ? false : true}
              formRef={formRef}
              handleOutsideButton={handleOutsideButton}
              handleSubmit={handleSubmit}
              classificationNameValidation={classificationNameValidation}
            />
            {isToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent="success" position="top-end" title="Success" message={(!saveBtnClicked && overlayName == '') ? "Automation Deleted Successfully" : overlayName == 'addAutomation' ? "New Automation Created Successfully" : "Automation Edited Successfully"} footer="" />}

            {errorToast && (<ToastComponent setmessagebar={setErrorToast} toastIntent="error" position="top-end" title="Failed" message={toastMessage} footer="" />)}
            {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}

          </StackItem>
          <StackItem><Text></Text></StackItem>
        </Stack>
      </FullScreen>

    </>
  );
};